import components from './components';
import globals from './globals';
import pages from './pages';
const main = Object.assign(Object.assign(Object.assign({}, globals), components), pages);
export default main;
